(ns minorodata.logs.events
(:require [minorodata.app.handlers :refer [reg-event-fx]]
          [minorodata.app.utils :as utils]
          [re-posh.core :as re-posh]))


(reg-event-fx
 :logs.events/save-config-to-local-storage
 (fn [_ _]
   (let [config-key @(re-posh/subscribe [:logs.misc/config-local-storage-key])
         props      @(re-posh/subscribe [:logs-view/pull])
         {:logs-view/keys [type page sort-by sort-order source term date-from date-to]} props]
     {:set-local-storage [config-key (utils/assoc-some {}
                                                       :page       page
                                                       :sort-by    sort-by
                                                       :sort-order sort-order
                                                       :source     source
                                                       :type       type
                                                       :term       term
                                                       :date-from  date-from
                                                       :date-to    date-to)]})))
